import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';

import routes from './routes';

import {
  checkAuthGuard,
  passFromRouteGuard,
  townshipLocaleGuardFactory,
  trackLandingGuard,
} from './guards';

Vue.use(VueRouter);
Vue.use(VueMeta);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
  routes,
});

router.beforeEach(passFromRouteGuard);
router.beforeEach(checkAuthGuard);
router.beforeEach(townshipLocaleGuardFactory(router));

router.afterEach(trackLandingGuard);

export default router;
